import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { BehaviorSubject, Observable, of } from "rxjs";
import { WorkOrderService } from "../services/work.order.service";
import { WorkOrder } from "../../shared/models/work.order.interface";
import { catchError, finalize } from "rxjs/operators";
import { WorkOrderFilter } from "../models/work.order.filter";

export class WorkOrdersDataSource implements DataSource<WorkOrder> {
  private workOrdersSubject = new BehaviorSubject<WorkOrder[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private workOrderService: WorkOrderService) { }

  connect(collectionViewer: CollectionViewer): Observable<WorkOrder[]> {
    return this.workOrdersSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.workOrdersSubject.complete();
    this.loadingSubject.complete();
  }

  loadWorkOrders(filter: WorkOrderFilter,
    sortColumn = 'projectName', sortDirection = 'asc', pageIndex = 0) {

    this.loadingSubject.next(true);

    this.workOrderService.getList(filter, sortColumn, sortDirection, pageIndex).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
      .subscribe(lessons => this.workOrdersSubject.next(lessons));
  }
}
